export enum DEBUG_PARAMS {
	ENABLE_DEBUG_LOGS = 'DEBUG',
	DEBUG_COOKIE_SCRIPT = 'DEBUG_COOKIE_SCRIPT',
	DEBUG_MIX_PANEL = 'DEBUG_MIX_PANEL',
}
export const isDebugParamEnabled = (param: DEBUG_PARAMS) => {
	return window.location.search.indexOf(`${param}=1`) > 0;
};
